import {
  electricPurple800,
  monserratRegular,
  robotoRegular,
  scarpaGray50,
  scarpaGray500,
} from '@habitech/shared';
import { styled } from 'styled-components';

export const WrapperModal = styled.div`
  padding: 24px;
  background: ${scarpaGray50};
  color: ${scarpaGray500};
  border-radius: 8px;
  .subtitle {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 14px;
    padding-bottom: 8px;
  }
  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: ${electricPurple800};
    font-family: ${monserratRegular};
  }
  .form-label,
  .form-control,
  .form-select {
    font-size: 14px;
    font-family: ${robotoRegular};
    padding-bottom: 2px;
  }
  .form-control {
    height: 100px;
  }
  .form-select {
    height: auto;
    font-size: 14px;
    font-family: ${robotoRegular};
  }
  textarea {
    overflow: auto;
    scrollbar-width: none;
  }
  textarea::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledPropertyTypeCheckbox = styled.div`
  .form-label {
    font-size: 14px;
    font-family: ${robotoRegular};
  }

  .form-check-label {
    font-size: 14px;
    font-family: ${robotoRegular};
  }

  .form-check-input:checked {
    background-color: #7c01ff;
    border-color: #7c01ff;
  }

  .form-check-input:focus {
    border-color: #7c01ff;
    box-shadow: 0 0 0 0.25rem rgba(124, 1, 255, 0.25);
  }
`;

export const StyledPolygonTypeCheckbox = styled.div`
  .form-label {
    font-size: 14px;
    font-family: ${robotoRegular};
  }

  .form-check-label {
    font-size: 14px;
    font-family: ${robotoRegular};
  }

  .form-check-input:checked {
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .form-check-input:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  }
`;

export const StyledPolygonTypeFilter = styled.div`
  display: inline-flex;

  .btn-group {
    gap: 0;
  }

  button {
    font-family: ${robotoRegular};
    font-size: 13px;
  }
`;
